import type { HistoryAddress, HistoryLocation } from '../../api/private-event-history';

const NONE = '—';

export function isLocation(v: unknown): v is HistoryLocation {
  return typeof v === 'object' && v !== null && 'label' in v && 'kind' in v;
}

/** "1201 Western Ave, Suite 4, Seattle, WA 98109". The name is the label's job. */
export function formatAddress(address: HistoryAddress | null | undefined): string {
  if (!address) return NONE;
  const region = [address.state, address.zipCode].filter(Boolean).join(' ');
  const parts = [address.addressLine1, address.addressLine2, address.city, region];
  return parts.filter(Boolean).join(', ') || NONE;
}

export interface LocationRow {
  label: string;
  before: string;
  after: string;
}

/** A location change reads as its label, and as its address when that moved
 *  too: a zip-only edit leaves the label alone but is still a change. */
export function locationRows(before: unknown, after: unknown): LocationRow[] {
  const b = isLocation(before) ? before : null;
  const a = isLocation(after) ? after : null;
  const labelRow = { label: 'Location', before: b?.label ?? NONE, after: a?.label ?? NONE };
  const addressBefore = formatAddress(b?.address);
  const addressAfter = formatAddress(a?.address);
  if (addressBefore === addressAfter) return [labelRow];
  const addressRow = { label: 'Address', before: addressBefore, after: addressAfter };
  return labelRow.before === labelRow.after ? [addressRow] : [labelRow, addressRow];
}
